export default class DeliveryOrderActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static GET_HELPER_DELIVERYORDER='GET_HELPER_DELIVERYORDER';
    static GET_HELPER_DELIVERYORDER_FULL ='GET_HELPER_DELIVERYORDER_FULL';
    static BEFORE_PRINT_DELIVERYORDER ='BEFORE_PRINT_DELIVERYORDER';
    static PRINT_DELIVERYORDER ='PRINT_DELIVERYORDER';
    static RESET_LIST="RESET_LIST";
  
    static submit(){
      return {
        type: DeliveryOrderActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: DeliveryOrderActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: DeliveryOrderActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: DeliveryOrderActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: DeliveryOrderActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: DeliveryOrderActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: DeliveryOrderActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: DeliveryOrderActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: DeliveryOrderActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: DeliveryOrderActions.RESET_DATA,
      };
    }
    static resetList(){
      return {
        type: DeliveryOrderActions.RESET_LIST,
      };
    }
  
    static helper(data){
      return {
        type: DeliveryOrderActions.GET_HELPER_DELIVERYORDER_FULL,
        payload:data
      };
    }

    static helperFull(data){
      return {
        type:  DeliveryOrderActions.GET_HELPER_DELIVERYORDER,
        payload:data
      };
    }
    static beforePrint(){
      return {
        type: DeliveryOrderActions.BEFORE_PRINT_DELIVERYORDER,
      };
    }
    static print(data){
      return {
        type: DeliveryOrderActions.PRINT_DELIVERYORDER,
        payload: data
      };
    }
  }
  
  